var SUPPORT_EMAIL_ADDRESS = 'support@happynumbers.com';
export { SUPPORT_EMAIL_ADDRESS };
